// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 2616); hand-edits allowed (see docs/architecture.md)

/** `this.WEAPONS_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_WEAPONS_DEF(): any {
  return {
    "bazooka": {
      "id": 1,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 1000,
      "diam": 1,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Базука"
    },
    "unfail_bazooka": {
      "id": 2,
      "level": 2,
      "spec_mod": "",
      "delay": 0,
      "gold": 4000,
      "diam": 4,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная базука"
    },
    "fire_bazooka": {
      "id": 3,
      "level": 8,
      "spec_mod": "",
      "delay": 0,
      "gold": 12000,
      "diam": 10,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Зажигательная базука"
    },
    "poison_bazooka": {
      "id": 4,
      "level": 11,
      "spec_mod": "",
      "delay": 0,
      "gold": 15000,
      "diam": 12,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Отравленная базука"
    },
    "ap_bazooka": {
      "id": 5,
      "level": 28,
      "spec_mod": "",
      "delay": 0,
      "gold": 30000,
      "diam": 30,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 20,
      "crit": 0,
      "add_damage": { "mode": "ap", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Бронебойная базука"
    },
    "howitzer": {
      "id": 102,
      "level": 39,
      "spec_mod": "",
      "delay": 0,
      "gold": 156000,
      "diam": 124,
      "wptype": "p",
      "damage": 3360,
      "limit": 3,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 85,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Кумулятивный снаряд 203мм"
    },
    "grenade": {
      "id": 6,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 1000,
      "diam": 1,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Граната"
    },
    "unfail_grenade": {
      "id": 7,
      "level": 3,
      "spec_mod": "",
      "delay": 0,
      "gold": 4000,
      "diam": 4,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная граната"
    },
    "plasma_grenade": {
      "id": 8,
      "level": 14,
      "spec_mod": "",
      "delay": 0,
      "gold": 24000,
      "diam": 21,
      "wptype": "p",
      "damage": 110,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Плазменная граната"
    },
    "pulse_grenade": {
      "id": 9,
      "level": 19,
      "spec_mod": "elec",
      "delay": 0,
      "gold": 29000,
      "diam": 27,
      "wptype": "p",
      "damage": 110,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Импульсная граната"
    },
    "holy_hand_grenade": {
      "id": 10,
      "level": 8,
      "spec_mod": "holy",
      "delay": 0,
      "gold": 40000,
      "diam": 37,
      "wptype": "p",
      "damage": 160,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Святая граната"
    },
    "cluster_bomb": {
      "id": 11,
      "level": 2,
      "spec_mod": "",
      "delay": 0,
      "gold": 1500,
      "diam": 2,
      "wptype": "p",
      "damage": 15,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "cluster", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Осколочная граната"
    },
    "unfail_cluster_bomb": {
      "id": 12,
      "level": 6,
      "spec_mod": "",
      "delay": 0,
      "gold": 5500,
      "diam": 5,
      "wptype": "p",
      "damage": 15,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "cluster", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотк. осколочная граната"
    },
    "molotov": {
      "id": 13,
      "level": 6,
      "spec_mod": "",
      "delay": 0,
      "gold": 2500,
      "diam": 3,
      "wptype": "p",
      "damage": 45,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Коктейль Молотова"
    },
    "mortar": {
      "id": 14,
      "level": 7,
      "spec_mod": "",
      "delay": 0,
      "gold": 2000,
      "diam": 3,
      "wptype": "p",
      "damage": 15,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "cluster", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Мортира"
    },
    "upg_mortar": {
      "id": 15,
      "level": 10,
      "spec_mod": "",
      "delay": 0,
      "gold": 5000,
      "diam": 4,
      "wptype": "p",
      "damage": 25,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 20,
      "add_damage": { "mode": "cluster", "amount": 6 },
      "shown": true,
      "allow_upg": true,
      "name": "Улучшенная мортира"
    },
    "putty_grenade": {
      "id": 98,
      "level": 10,
      "spec_mod": "",
      "delay": 0,
      "gold": 59000,
      "diam": 57,
      "wptype": "p",
      "damage": 100,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 10,
      "add_damage": { "mode": "cluster", "amount": 8 },
      "shown": true,
      "allow_upg": true,
      "name": "Граната-липучка"
    },
    "banana_bomb": {
      "id": 16,
      "level": 15,
      "spec_mod": "",
      "delay": 0,
      "gold": 35000,
      "diam": 35,
      "wptype": "p",
      "damage": 75,
      "limit": 3,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "cluster", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Банано-бомба"
    },
    "unfail_banana_bomb": {
      "id": 17,
      "level": 20,
      "spec_mod": "",
      "delay": 0,
      "gold": 42000,
      "diam": 41,
      "wptype": "p",
      "damage": 75,
      "limit": 3,
      "ai_type": "gravity",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "cluster", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная банано-бомба"
    },
    "super_banana_bomb": {
      "id": 18,
      "level": 22,
      "spec_mod": "",
      "delay": 0,
      "gold": 84000,
      "diam": 81,
      "wptype": "p",
      "damage": 75,
      "limit": 5,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "cluster", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Супер банано-бомба"
    },
    "nuclear_bomb": {
      "id": 19,
      "level": 25,
      "spec_mod": "",
      "delay": 0,
      "gold": 53000,
      "diam": 53,
      "wptype": "p",
      "damage": 600,
      "limit": 3,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 10,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "ICBM"
    },
    "multi_bazooka": {
      "id": 20,
      "level": 26,
      "spec_mod": "",
      "delay": 0,
      "gold": 46000,
      "diam": 43,
      "wptype": "p",
      "damage": 50,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "multi_shots", "amount": 4 },
      "shown": true,
      "allow_upg": true,
      "name": "Многозарядный ракетомет"
    },
    "dl19": {
      "id": 50,
      "level": 31,
      "spec_mod": "",
      "delay": 0,
      "gold": 89000,
      "diam": 82,
      "wptype": "p",
      "damage": 200,
      "limit": 5,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "cluster", "amount": 4, "a_dmg": 100 },
      "shown": true,
      "allow_upg": true,
      "name": "Граната DL19"
    },
    "rj46": {
      "id": 55,
      "level": 33,
      "spec_mod": "",
      "delay": 0,
      "gold": 96000,
      "diam": 93,
      "wptype": "p",
      "damage": 200,
      "limit": 5,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 10,
      "add_damage": { "mode": "cluster", "amount": 5, "a_dmg": 100 },
      "shown": true,
      "allow_upg": true,
      "name": "Зажигательная базука Mk 2"
    },
    "ap_bazooka2": {
      "id": 109,
      "level": 46,
      "spec_mod": "",
      "delay": 0,
      "gold": 100000,
      "diam": 98,
      "wptype": "p",
      "damage": 140,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 25,
      "crit": 0,
      "add_damage": { "mode": "ap", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Бронебойная базука Mk 2"
    },
    "mega_banana_bomb": {
      "id": 110,
      "level": 56,
      "spec_mod": "",
      "delay": 0,
      "gold": 160000,
      "diam": 147,
      "wptype": "p",
      "damage": 150,
      "limit": 3,
      "ai_type": "gravity",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "banana", "amount": 4, "a_dmg": 75 },
      "shown": true,
      "allow_upg": true,
      "name": "Мега банано-бомба"
    },
    "pistol": {
      "id": 21,
      "level": 1,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 300,
      "diam": 1,
      "wptype": "f",
      "damage": 6,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Пистолет 10мм"
    },
    "uzi": {
      "id": 22,
      "level": 4,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 2000,
      "diam": 2,
      "wptype": "f",
      "damage": 5,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Узи 9мм"
    },
    "unfail_uzi": {
      "id": 23,
      "level": 9,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 6000,
      "diam": 5,
      "wptype": "f",
      "damage": 5,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказный Узи 9мм"
    },
    "hunting_rifle": {
      "id": 24,
      "level": 10,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 6000,
      "diam": 6,
      "wptype": "f",
      "damage": 32,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "multi_shots", "amount": 2 },
      "shown": true,
      "allow_upg": true,
      "name": "Дробовик .410"
    },
    "sniper_rifle": {
      "id": 25,
      "level": 17,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 16000,
      "diam": 11,
      "wptype": "f",
      "damage": 250,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 1 },
      "shown": true,
      "allow_upg": true,
      "name": "Снайперская винтовка 7.62мм"
    },
    "peacemaker": {
      "id": 101,
      "level": 28,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 56000,
      "diam": 49,
      "wptype": "f",
      "damage": 250,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 15,
      "crit": 25,
      "add_damage": { "mode": "shots", "amount": 2 },
      "shown": true,
      "allow_upg": true,
      "name": "Миротворец .577"
    },
    "shotgun": {
      "id": 26,
      "level": 3,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 1500,
      "diam": 2,
      "wptype": "f",
      "damage": 25,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "multi_shots", "amount": 2 },
      "shown": true,
      "allow_upg": true,
      "name": "Двустволка .45"
    },
    "minigun": {
      "id": 27,
      "level": 11,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 6500,
      "diam": 7,
      "wptype": "f",
      "damage": 4,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": true,
      "allow_upg": true,
      "name": "Пулемет 5.56мм"
    },
    "unfail_minigun": {
      "id": 28,
      "level": 15,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 14000,
      "diam": 13,
      "wptype": "f",
      "damage": 4,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказный пулемет 5.56мм"
    },
    "air_minigun": {
      "id": 29,
      "level": 24,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 31000,
      "diam": 25,
      "wptype": "f",
      "damage": 12,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 30 },
      "shown": true,
      "allow_upg": true,
      "name": "Авиационный пулемет 13мм"
    },
    "bozar": {
      "id": 30,
      "level": 32,
      "spec_mod": "riflegun",
      "delay": 0,
      "gold": 49000,
      "diam": 36,
      "wptype": "f",
      "damage": 26,
      "limit": 10,
      "ai_type": "",
      "unfail": 150,
      "ap_mod": 15,
      "crit": 20,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": true,
      "allow_upg": true,
      "name": "Бозар G9 12.5мм"
    },
    "rad_rifle": {
      "id": 103,
      "level": 34,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 83000,
      "diam": 81,
      "wptype": "f",
      "damage": 900,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 20,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 1 },
      "shown": true,
      "allow_upg": true,
      "name": "Радиевая винтовка"
    },
    "avenger": {
      "id": 100,
      "level": 36,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 109000,
      "diam": 98,
      "wptype": "f",
      "damage": 40,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 30 },
      "shown": true,
      "allow_upg": true,
      "name": "Пулемет Авенджер 20мм"
    },
    "air_strike": {
      "id": 31,
      "level": 6,
      "spec_mod": "",
      "delay": 2,
      "gold": 5200,
      "diam": 5,
      "wptype": "a",
      "damage": 25,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "airstrike", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Воздушный удар"
    },
    "napalm_strike": {
      "id": 32,
      "level": 9,
      "spec_mod": "",
      "delay": 4,
      "gold": 6000,
      "diam": 6,
      "wptype": "a",
      "damage": 0,
      "limit": 6,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Удар напалмом"
    },
    "mine_strike": {
      "id": 33,
      "level": 11,
      "spec_mod": "",
      "delay": 3,
      "gold": 16000,
      "diam": 15,
      "wptype": "a",
      "damage": 50,
      "limit": 6,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "airstrike", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Минный удар"
    },
    "banana_strike": {
      "id": 34,
      "level": 27,
      "spec_mod": "",
      "delay": 0,
      "gold": 88000,
      "diam": 80,
      "wptype": "a",
      "damage": 75,
      "limit": 4,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "airstrike", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Банановый удар"
    },
    "holy_strike": {
      "id": 35,
      "level": 31,
      "spec_mod": "holy",
      "delay": 0,
      "gold": 94000,
      "diam": 86,
      "wptype": "a",
      "damage": 160,
      "limit": 3,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "airstrike", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Святой удар"
    },
    "mine": {
      "id": 36,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 800,
      "diam": 1,
      "wptype": "e",
      "damage": 50,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Мина"
    },
    "unfail_mine": {
      "id": 37,
      "level": 4,
      "spec_mod": "",
      "delay": 0,
      "gold": 2500,
      "diam": 3,
      "wptype": "e",
      "damage": 50,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная мина"
    },
    "fire_mine": {
      "id": 38,
      "level": 8,
      "spec_mod": "",
      "delay": 0,
      "gold": 12000,
      "diam": 10,
      "wptype": "e",
      "damage": 50,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Зажигательная мина"
    },
    "plasma_mine": {
      "id": 39,
      "level": 13,
      "spec_mod": "",
      "delay": 0,
      "gold": 19000,
      "diam": 17,
      "wptype": "e",
      "damage": 110,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Плазменная мина"
    },
    "pulse_mine": {
      "id": 40,
      "level": 18,
      "spec_mod": "elec",
      "delay": 0,
      "gold": 27000,
      "diam": 25,
      "wptype": "e",
      "damage": 110,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Импульсная мина"
    },
    "nuclear_mine": {
      "id": 104,
      "level": 22,
      "spec_mod": "",
      "delay": 0,
      "gold": 41000,
      "diam": 40,
      "wptype": "e",
      "damage": 450,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Урановая мина UN14"
    },
    "dynamite": {
      "id": 41,
      "level": 4,
      "spec_mod": "",
      "delay": 0,
      "gold": 3000,
      "diam": 3,
      "wptype": "e",
      "damage": 75,
      "limit": 6,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Динамит"
    },
    "unfail_dynamite": {
      "id": 42,
      "level": 7,
      "spec_mod": "",
      "delay": 0,
      "gold": 5000,
      "diam": 5,
      "wptype": "e",
      "damage": 75,
      "limit": 6,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказный динамит"
    },
    "dynamite_bunch": {
      "id": 45,
      "level": 14,
      "spec_mod": "",
      "delay": 0,
      "gold": 29000,
      "diam": 28,
      "wptype": "e",
      "damage": 75,
      "limit": 6,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "cluster", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Связка динамита"
    },
    "old_woman": {
      "id": 46,
      "level": 5,
      "spec_mod": "",
      "delay": 0,
      "gold": 3000,
      "diam": 3,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Старушка"
    },
    "unfail_old_woman": {
      "id": 47,
      "level": 7,
      "spec_mod": "",
      "delay": 0,
      "gold": 5000,
      "diam": 4,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная старушка"
    },
    "sheep": {
      "id": 43,
      "level": 7,
      "spec_mod": "",
      "delay": 0,
      "gold": 3200,
      "diam": 3,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Овца"
    },
    "unfail_sheep": {
      "id": 44,
      "level": 10,
      "spec_mod": "",
      "delay": 0,
      "gold": 6000,
      "diam": 5,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная овца"
    },
    "fire_sheep": {
      "id": 48,
      "level": 9,
      "spec_mod": "",
      "delay": 0,
      "gold": 14000,
      "diam": 12,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Зажигательная овца"
    },
    "poison_sheep": {
      "id": 49,
      "level": 12,
      "spec_mod": "",
      "delay": 0,
      "gold": 18000,
      "diam": 14,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Отравленная овца"
    },
    "mine_sheep": {
      "id": 105,
      "level": 19,
      "spec_mod": "",
      "delay": 0,
      "gold": 33000,
      "diam": 32,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "mines", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Миновца"
    },
    "mine_sheep2": {
      "id": 106,
      "level": 27,
      "spec_mod": "",
      "delay": 0,
      "gold": 46000,
      "diam": 44,
      "wptype": "l",
      "damage": 75,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "pmines", "amount": 7 },
      "shown": true,
      "allow_upg": true,
      "name": "Миновца Mk 2"
    },
    "prod": {
      "id": 51,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 250,
      "diam": 1,
      "wptype": "c",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Тычок"
    },
    "firepunch": {
      "id": 52,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 400,
      "diam": 1,
      "wptype": "c",
      "damage": 30,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Огненный удар"
    },
    "fireball": {
      "id": 53,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 350,
      "diam": 1,
      "wptype": "c",
      "damage": 30,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Шар дракона"
    },
    "kamikaze": {
      "id": 54,
      "level": 33,
      "spec_mod": "",
      "delay": 0,
      "gold": 36000,
      "diam": 34,
      "wptype": "c",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Камикадзе"
    },
    "baseball_bat": {
      "id": 56,
      "level": 5,
      "spec_mod": "",
      "delay": 0,
      "gold": 4800,
      "diam": 5,
      "wptype": "c",
      "damage": 30,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Бейсбольная бита"
    },
    "shocker": {
      "id": 57,
      "level": 6,
      "spec_mod": "",
      "delay": 0,
      "gold": 5500,
      "diam": 6,
      "wptype": "c",
      "damage": 30,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Электрошокер"
    },
    "battle_axe": {
      "id": 58,
      "level": 8,
      "spec_mod": "",
      "delay": 0,
      "gold": 5100,
      "diam": 5,
      "wptype": "c",
      "damage": -2,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Боевой топор"
    },
    "power_axe": {
      "id": 59,
      "level": 20,
      "spec_mod": "",
      "delay": 0,
      "gold": 12000,
      "diam": 10,
      "wptype": "c",
      "damage": -3,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Силовой топор"
    },
    "power_bat": {
      "id": 60,
      "level": 21,
      "spec_mod": "",
      "delay": 0,
      "gold": 21000,
      "diam": 18,
      "wptype": "c",
      "damage": 60,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Силовая бейсбольная бита"
    },
    "skip_go": {
      "id": 61,
      "level": 1,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Пропуск хода"
    },
    "laser_sight": {
      "id": 62,
      "level": 2,
      "spec_mod": "",
      "delay": 0,
      "gold": 1200,
      "diam": 1,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Лазерный прицел"
    },
    "low_gravity": {
      "id": 63,
      "level": 3,
      "spec_mod": "",
      "delay": 0,
      "gold": 2000,
      "diam": 2,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Низкая гравитация"
    },
    "fast_walk": {
      "id": 64,
      "level": 5,
      "spec_mod": "",
      "delay": 0,
      "gold": 4000,
      "diam": 4,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Быстрая ходьба"
    },
    "ultra_scaner": {
      "id": 65,
      "level": 10,
      "spec_mod": "",
      "delay": Number.POSITIVE_INFINITY,
      "gold": 5000,
      "diam": 5,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Ультраволновой сканер"
    },
    "blow_torch": {
      "id": 66,
      "level": 2,
      "spec_mod": "",
      "delay": 0,
      "gold": 1800,
      "diam": 2,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Паяльная лампа"
    },
    "pneumatic_drill": {
      "id": 67,
      "level": 2,
      "spec_mod": "",
      "delay": 0,
      "gold": 1500,
      "diam": 2,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Отбойный молоток"
    },
    "parachute": {
      "id": 68,
      "level": 3,
      "spec_mod": "",
      "delay": 0,
      "gold": 2000,
      "diam": 2,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Парашют"
    },
    "girder": {
      "id": 69,
      "level": 4,
      "spec_mod": "",
      "delay": 0,
      "gold": 4235,
      "diam": 4,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Балка"
    },
    "girder_pack": {
      "id": 70,
      "level": 19,
      "spec_mod": "",
      "delay": 0,
      "gold": 36000,
      "diam": 31,
      "wptype": "u",
      "damage": 0,
      "limit": 2,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Набор балок"
    },
    "jet_pack": {
      "id": 71,
      "level": 16,
      "spec_mod": "",
      "delay": 0,
      "gold": 20000,
      "diam": 20,
      "wptype": "u",
      "damage": 0,
      "limit": 4,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Реактивный ранец"
    },
    "teleport": {
      "id": 72,
      "level": 8,
      "spec_mod": "",
      "delay": 0,
      "gold": 6000,
      "diam": 6,
      "wptype": "u",
      "damage": 0,
      "limit": 6,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Телепорт"
    },
    "upg_teleport": {
      "id": 73,
      "level": 21,
      "spec_mod": "",
      "delay": 0,
      "gold": 51000,
      "diam": 51,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Улучшенный телепорт"
    },
    "upg_jet_pack": {
      "id": 74,
      "level": 26,
      "spec_mod": "",
      "delay": 0,
      "gold": 28000,
      "diam": 25,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Улучш. реактивный ранец"
    },
    "ag_pack": {
      "id": 75,
      "level": 29,
      "spec_mod": "",
      "delay": 0,
      "gold": 33000,
      "diam": 31,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Антигравитационный ранец"
    },
    "add_time": {
      "id": 76,
      "level": 9,
      "spec_mod": "",
      "delay": 0,
      "gold": 4600,
      "diam": 5,
      "wptype": "u",
      "damage": 0,
      "limit": 3,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Дополнительное время"
    },
    "choose_worm": {
      "id": 77,
      "level": 10,
      "spec_mod": "",
      "delay": 0,
      "gold": 10000,
      "diam": 10,
      "wptype": "u",
      "damage": 0,
      "limit": 3,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Выбор червя"
    },
    "upg_teleport2": {
      "id": 78,
      "level": 35,
      "spec_mod": "",
      "delay": 0,
      "gold": 88000,
      "diam": 79,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Улучшенный телепорт Mk 2"
    },
    "medikit": {
      "id": 79,
      "level": 19,
      "spec_mod": "",
      "delay": 0,
      "gold": 23000,
      "diam": 21,
      "wptype": "u",
      "damage": 0,
      "limit": 5,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Походная аптечка"
    },
    "emg_teleport": {
      "id": 80,
      "level": 41,
      "spec_mod": "",
      "delay": Number.POSITIVE_INFINITY,
      "gold": 113000,
      "diam": 110,
      "wptype": "u",
      "damage": 0,
      "limit": 5,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Аварийный телепорт"
    },
    "super_medikit": {
      "id": 99,
      "level": 38,
      "spec_mod": "",
      "delay": 0,
      "gold": 47000,
      "diam": 46,
      "wptype": "u",
      "damage": 0,
      "limit": 5,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Супер-аптечка"
    },
    "gravity_grenade": {
      "id": 111,
      "level": 26,
      "spec_mod": "",
      "delay": 0,
      "gold": 51000,
      "diam": 49,
      "wptype": "u",
      "damage": 0,
      "limit": 4,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Гравитационная граната G1500"
    },
    "invisibility": {
      "id": 112,
      "level": 28,
      "spec_mod": "",
      "delay": 0,
      "gold": 67000,
      "diam": 64,
      "wptype": "u",
      "damage": 0,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": false,
      "name": "Частичная невидимость"
    },
    "laser_pistol": {
      "id": 81,
      "level": 12,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 12000,
      "diam": 12,
      "wptype": "h",
      "damage": 24,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Лазерный пистолет"
    },
    "laser_rifle": {
      "id": 82,
      "level": 18,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 23000,
      "diam": 21,
      "wptype": "h",
      "damage": 24,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Лазерная винтовка"
    },
    "unfail_laser_rifle": {
      "id": 83,
      "level": 25,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 35000,
      "diam": 33,
      "wptype": "h",
      "damage": 24,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотк. лазерная винтовка"
    },
    "laser_minigun": {
      "id": 84,
      "level": 37,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 53000,
      "diam": 50,
      "wptype": "h",
      "damage": 32,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": true,
      "allow_upg": true,
      "name": "Лазерный пулемет"
    },
    "pulse_pistol": {
      "id": 85,
      "level": 40,
      "spec_mod": "elec",
      "delay": 0,
      "gold": 164000,
      "diam": 110,
      "wptype": "h",
      "damage": 900,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 150,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Стэндиш 900"
    },
    "plasma_pistol": {
      "id": 86,
      "level": 14,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 15000,
      "diam": 15,
      "wptype": "h",
      "damage": 35,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Плазменный пистолет"
    },
    "plasma_rifle": {
      "id": 87,
      "level": 22,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 34000,
      "diam": 31,
      "wptype": "h",
      "damage": 35,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Плазменная винтовка"
    },
    "unfail_plasma_rifle": {
      "id": 88,
      "level": 27,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 43000,
      "diam": 36,
      "wptype": "h",
      "damage": 35,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 0,
      "crit": 50,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотк. плазменная винтовка"
    },
    "plasma_minigun": {
      "id": 89,
      "level": 41,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 106000,
      "diam": 99,
      "wptype": "h",
      "damage": 60,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": true,
      "allow_upg": true,
      "name": "Плазменный пулемет"
    },
    "luiston": {
      "id": 90,
      "level": 44,
      "spec_mod": "elec",
      "delay": 0,
      "gold": 190000,
      "diam": 130,
      "wptype": "h",
      "damage": 1300,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Льюистон Mk 17"
    },
    "gauss_pistol": {
      "id": 91,
      "level": 23,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 28000,
      "diam": 24,
      "wptype": "h",
      "damage": 350,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 150,
      "ap_mod": 30,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 1 },
      "shown": true,
      "allow_upg": true,
      "name": "Пистолет Гаусса PPK12"
    },
    "gauss_rifle": {
      "id": 92,
      "level": 30,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 43000,
      "diam": 40,
      "wptype": "h",
      "damage": 600,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 30,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 1 },
      "shown": true,
      "allow_upg": true,
      "name": "Винтовка Гаусса M72"
    },
    "unfail_gauss_rifle": {
      "id": 93,
      "level": 37,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 56000,
      "diam": 51,
      "wptype": "h",
      "damage": 600,
      "limit": 10,
      "ai_type": "",
      "unfail": 100,
      "ap_mod": 30,
      "crit": 50,
      "add_damage": { "mode": "shots", "amount": 1 },
      "shown": true,
      "allow_upg": true,
      "name": "Безотказная винтовка Гаусса M72"
    },
    "gauss_minigun": {
      "id": 94,
      "level": 47,
      "spec_mod": "minigun",
      "delay": 0,
      "gold": 185000,
      "diam": 160,
      "wptype": "h",
      "damage": 375,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 30,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 10 },
      "shown": true,
      "allow_upg": true,
      "name": "Гаусс-пулемет"
    },
    "de_lameter": {
      "id": 95,
      "level": 50,
      "spec_mod": "elec",
      "delay": 0,
      "gold": 340000,
      "diam": 269,
      "wptype": "h",
      "damage": 1850,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "ap", "amount": 3 },
      "shown": true,
      "allow_upg": true,
      "name": "Излучатель Де Ляметра"
    },
    "turbo_rifle": {
      "id": 107,
      "level": 64,
      "spec_mod": "elec",
      "delay": 0,
      "gold": 420000,
      "diam": 345,
      "wptype": "h",
      "damage": 1400,
      "limit": 10,
      "ai_type": "",
      "unfail": 150,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Турбовинтовка Де Ляметра"
    },
    "orbit_strike": {
      "id": 96,
      "level": 58,
      "spec_mod": "",
      "delay": 0,
      "gold": 330000,
      "diam": 204,
      "wptype": "a",
      "damage": 1300,
      "limit": 3,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 0,
      "crit": 0,
      "add_damage": { "mode": "airstrike", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Удар с орбиты"
    },
    "ultra_rifle": {
      "id": 97,
      "level": 62,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 260000,
      "diam": 215,
      "wptype": "h",
      "damage": 2000,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 0,
      "ap_mod": 5,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": true,
      "allow_upg": true,
      "name": "Ультраволновая винтовка"
    },
    "vindicator": {
      "id": 108,
      "level": 69,
      "spec_mod": "rifle",
      "delay": 0,
      "gold": 510000,
      "diam": 455,
      "wptype": "h",
      "damage": 2000,
      "limit": 10,
      "ai_type": "",
      "unfail": 150,
      "ap_mod": 5,
      "crit": 0,
      "add_damage": { "mode": "shots", "amount": 5 },
      "shown": true,
      "allow_upg": true,
      "name": "Виндикатор M143"
    },
    "laser_pistol2": {
      "id": 113,
      "level": 15,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 21000,
      "diam": 18,
      "wptype": "h",
      "damage": 30,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 15,
      "crit": 20,
      "add_damage": { "mode": "shots", "amount": 7 },
      "shown": false,
      "allow_upg": true,
      "name": "Лазерный пистолет Mk 2"
    },
    "nuclear_bomb2": {
      "id": 114,
      "level": 35,
      "spec_mod": "",
      "delay": 0,
      "gold": 78000,
      "diam": 76,
      "wptype": "p",
      "damage": 900,
      "limit": 3,
      "ai_type": "wind",
      "unfail": 0,
      "ap_mod": 15,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": true,
      "name": "ICBM Rad-14"
    },
    "super_hhg": {
      "id": 115,
      "level": 29,
      "spec_mod": "holy",
      "delay": 0,
      "gold": 54000,
      "diam": 51,
      "wptype": "p",
      "damage": 250,
      "limit": 6,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 100,
      "crit": 20,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": true,
      "name": "Супер святая граната"
    },
    "gauss_pistol2": {
      "id": 116,
      "level": 31,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 47000,
      "diam": 46,
      "wptype": "h",
      "damage": 375,
      "limit": 10,
      "ai_type": "",
      "unfail": 150,
      "ap_mod": 30,
      "crit": 0,
      "add_damage": { "mode": "multi_shots", "amount": 2 },
      "shown": false,
      "allow_upg": true,
      "name": "Пистолет Гаусса PPK19"
    },
    "hearts_ace": {
      "id": 117,
      "level": 47,
      "spec_mod": "pistol",
      "delay": 0,
      "gold": 113000,
      "diam": 110,
      "wptype": "f",
      "damage": 300,
      "limit": 10,
      "ai_type": "",
      "unfail": 0,
      "ap_mod": 20,
      "crit": 25,
      "add_damage": { "mode": "shots", "amount": 2 },
      "shown": false,
      "allow_upg": true,
      "name": "Туз Червей .577"
    },
    "bozar16": {
      "id": 118,
      "level": 49,
      "spec_mod": "riflegun",
      "delay": 0,
      "gold": 167000,
      "diam": 164,
      "wptype": "f",
      "damage": 100,
      "limit": 10,
      "ai_type": "",
      "unfail": 150,
      "ap_mod": 20,
      "crit": 20,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": false,
      "allow_upg": true,
      "name": "Бозар G16 RAD"
    },
    "bozar24s": {
      "id": 119,
      "level": 61,
      "spec_mod": "riflegun",
      "delay": 0,
      "gold": 205000,
      "diam": 204,
      "wptype": "f",
      "damage": 125,
      "limit": 10,
      "ai_type": "",
      "unfail": 150,
      "ap_mod": 100,
      "crit": 20,
      "add_damage": { "mode": "shots", "amount": 20 },
      "shown": false,
      "allow_upg": true,
      "name": "Бозар G24s RAD"
    },
    "kenton_bazooka": {
      "id": 120,
      "level": 0,
      "spec_mod": "",
      "delay": 0,
      "gold": 400000,
      "diam": 0,
      "wptype": "p",
      "damage": 1200,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 150,
      "ap_mod": 100,
      "crit": 25,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Кентонская базука"
    },
    "kenton_grenade": {
      "id": 121,
      "level": 0,
      "spec_mod": "",
      "delay": 0,
      "gold": 400000,
      "diam": 0,
      "wptype": "p",
      "damage": 1200,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 150,
      "ap_mod": 100,
      "crit": 25,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Кентонская граната"
    },
    "void_melody": {
      "id": 122,
      "level": 0,
      "spec_mod": "",
      "delay": 0,
      "gold": 1200000,
      "diam": 0,
      "wptype": "h",
      "damage": 15000,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 150,
      "ap_mod": 100,
      "crit": 25,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Мелодия пустоты"
    },
    "annihilator": {
      "id": 123,
      "level": 80,
      "spec_mod": "",
      "delay": 0,
      "gold": 1500000,
      "diam": 986,
      "wptype": "h",
      "damage": 12000,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 150,
      "ap_mod": 100,
      "crit": 0,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Анигиллятор A3000"
    },
    "rez124": { "id": 124, "level": -1 },
    "rez125": { "id": 125, "level": -1 },
    "rez126": { "id": 126, "level": -1 },
    "rez127": { "id": 127, "level": -1 },
    "rez128": { "id": 128, "level": -1 },
    "rez129": { "id": 129, "level": -1 },
    "rez130": { "id": 130, "level": -1 },
    "rez131": { "id": 131, "level": -1 },
    "rez132": { "id": 132, "level": -1 },
    "rez133": { "id": 133, "level": -1 },
    "rez134": { "id": 134, "level": -1 },
    "rez135": { "id": 135, "level": -1 },
    "rez136": { "id": 136, "level": -1 },
    "rez137": { "id": 137, "level": -1 },
    "rez138": { "id": 138, "level": -1 },
    "rez139": { "id": 139, "level": -1 },
    "rez140": { "id": 140, "level": -1 },
    "rez141": { "id": 141, "level": -1 },
    "rez142": { "id": 142, "level": -1 },
    "rez143": { "id": 143, "level": -1 },
    "rez144": { "id": 144, "level": -1 },
    "beretta": {
      "id": 201,
      "level": 0,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "f",
      "damage": 75,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 100,
      "ap_mod": 50,
      "crit": 70,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Беретта M-92F"
    },
    "laser_at_rifle": {
      "id": 202,
      "level": 24,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "h",
      "damage": 250,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 100,
      "ap_mod": 20,
      "crit": 30,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Лазерная противотанковая винтовка"
    },
    "plasma_at_rifle": {
      "id": 203,
      "level": 25,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "h",
      "damage": 450,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 100,
      "ap_mod": 20,
      "crit": 30,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Плазменная противотанковая винтовка"
    },
    "multip14": {
      "id": 204,
      "level": 40,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "p",
      "damage": 400,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 100,
      "ap_mod": 10,
      "crit": 10,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Базука MULTI P-14"
    },
    "multip17": {
      "id": 205,
      "level": 45,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "p",
      "damage": 500,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 100,
      "ap_mod": 20,
      "crit": 15,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Базука MULTI P-17 AP"
    },
    "rainbow_burst": {
      "id": 206,
      "level": 40,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "p",
      "damage": 400,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 100,
      "ap_mod": 10,
      "crit": 10,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Граната Rainbow Burst"
    },
    "infinity_rainbow": {
      "id": 207,
      "level": 45,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "p",
      "damage": 500,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 100,
      "ap_mod": 20,
      "crit": 15,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Граната Infinity Rainbow"
    },
    "ec_caws": {
      "id": 208,
      "level": 45,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "h",
      "damage": 2000,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 100,
      "ap_mod": 40,
      "crit": 20,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "EC CAWS"
    },
    "ec_panhammer": {
      "id": 209,
      "level": 46,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "h",
      "damage": 2500,
      "limit": 10,
      "ai_type": "linear",
      "unfail": 100,
      "ap_mod": 40,
      "crit": 25,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "EC Panhammer"
    },
    "multip83": {
      "id": 210,
      "level": 45,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "p",
      "damage": 800,
      "limit": 10,
      "ai_type": "wind",
      "unfail": 100,
      "ap_mod": 20,
      "crit": 15,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Базука MULTI P-83 AP+"
    },
    "skyfire": {
      "id": 211,
      "level": 45,
      "spec_mod": "",
      "delay": 0,
      "gold": 0,
      "diam": 0,
      "wptype": "p",
      "damage": 800,
      "limit": 10,
      "ai_type": "gravity",
      "unfail": 100,
      "ap_mod": 20,
      "crit": 15,
      "add_damage": { "mode": "none" },
      "shown": false,
      "allow_upg": false,
      "name": "Граната Skyfire"
    }
  };
}
